import { createContext, useContext } from 'react';
import { Vault } from '../types/vaults';
import { MetricsData, NetworkYieldSources } from '../types/yieldData';

export interface RewardData {
  [key: string]: string;
}

export interface UserBalances {
  global: number;
  [key: string]: number;
}

export interface YieldData {
  timestamp: string;
  networks: NetworkYieldSources;
}

export interface AppContextData {
  vaults: Vault[];
  rewardData: RewardData;
  userBalances: UserBalances;
  instancesLiveData: MetricsData;
  yieldData: YieldData;
}

export const AppContext = createContext<AppContextData | undefined>(undefined);

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppContextProvider');
  }
  return context;
};
